import React,{useState,useEffect} from 'react'
import AppHeader from '../../components/AppHeader'
import portalServices from '../../portalServices';
import { useLocation, useNavigate, useParams } from 'react-router-dom';


import { Step, StepLabel, Stepper } from '@mui/material';
import { ArrowCircleRight } from '@mui/icons-material';
import CheckinBackButton from '../CheckinBackButton';
const Step2 = ({queue}) =>{
  return (
    <div className='col-md-12 mt-3 mb-5'>
      <Stepper activeStep={1}>
        <Step>
          <StepLabel>{queue.title}</StepLabel>
        </Step>
        <Step>
          <StepLabel>Select Service</StepLabel>
        </Step>
        <Step>
          <StepLabel>Book Token</StepLabel>
        </Step>
      </Stepper>
    </div>
  )
}

function SelectServicesPage() {

  const location = useLocation();
	const queue = location.state;

  const queueId = queue?queue.id:null;
  const navigate = useNavigate();

  const [serviceList,setServiceList] = useState(null);
  const getServiceList = () =>{
    portalServices.getServiceList(queueId).then(res=>{
      setServiceList(res.data);
    }).catch(error=>{

    })
  }
  useEffect(()=>{
    getServiceList();
  },[])

  const selectService = (service) =>{
      navigate("/checkin/form",{state:{queue,queue,service,service}})
  }

  useEffect(()=>{
    if(queue==null){
      navigate("/checkin/queue")
    }
  },[])

  return (
    <>
        <AppHeader/>
        {queue &&
        <div className='container'>
            <CheckinBackButton/>
            <div className='row'>
                <Step2 queue={queue} />
                <div className='col-md-12'>
                    {serviceList && serviceList.map(service=>
                      <div key={service.id} className="card px-3 py-3 mb-2" onClick={()=>selectService(service)} style={{cursor:"pointer"}}>

                          <div className=' d-flex justify-content-between'>
                            <div className='fw-bold'>{service.title}</div>
                            <ArrowCircleRight/>
                          </div>


                      </div>
                    )}
                </div>
            </div>
        </div>
        }
    </>
  )
}

export default SelectServicesPage